import React from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import clsx from "clsx";
import Theme from "./../.themes/common/Theme";

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  price: {
    paddingRight: 5,
    paddingLeft: 5,
    fontSize: "20px",
    whiteSpace: "nowrap",
  },
  currency: {
    fontSize: "16px",
    whiteSpace: "nowrap",
  },
  priceOld: {
    paddingRight: 5,
    paddingLeft: 5,
    fontSize: "18px",
    whiteSpace: "nowrap",
    textDecoration: "line-through",
    color: `${theme.palette.disabledColor} !important` || "#676767 !important",
  },
  currencyOld: {
    textDecoration: "line-through",
    color: `${theme.palette.disabledColor} !important` || "#676767 !important",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
}));

type justifyContent = "flex-end" | "center" | "flex-start";

interface IPriceTagProps {
  priceText: string;
  textVariant?: Variant;
  justifyContent?: justifyContent;
  fontWeight?: number;
  textClassName?: string;
  variant?: "normal" | "oldPrice";
}

export const PriceTag: React.FC<IPriceTagProps> = (props: IPriceTagProps) => {
  const css = useStyles();
  const splitedPriceTag = props.priceText?.split(" ");
  let priceClasses = clsx(css.price, props.textClassName);
  let currencyClasses = clsx(css.currency, props.textClassName);

  if (props.variant === "oldPrice") {
    priceClasses = clsx(css.priceOld, props.textClassName);
    currencyClasses = clsx(css.currencyOld, props.textClassName);
  }

  const renderPrice = () => {
    const splittedPriceTagElement = splitedPriceTag?.map((val, key) => (
      <Typography key={key} variant={props.textVariant} className={isNaN(Number(val)) ? currencyClasses : priceClasses}>
        {val}
      </Typography>
    ));
    return splittedPriceTagElement;
  };

  return (
    <Box display='flex' justifyContent={props.justifyContent ?? "flex-end"} alignItems='baseline' flexWrap='wrap' id='ws-priceTag'>
      {renderPrice()}
    </Box>
  );
};

export default PriceTag;
